import { AsyncPipe, CommonModule, NgForOf, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular/lazy';
import { TranslateModule } from '@ngx-translate/core';

import { NotificationProgressComponent } from '@/app/app/components/notification-progress/notification-progress.component';
import { PageHeaderComponent } from '@/app/app/components/page-header/page-header.component';
import { DateExtension } from '@/app/app/services/extensions/date.extension';
import { DateFormatExtension } from '@/app/app/services/extensions/datepipe.extension';
import { ListToValueExtension } from '@/app/app/services/extensions/list-to-value.extension';
import { MonitoringStatusIconExtension } from '@/app/app/services/extensions/monitoring/monitoring-status-icon.extension';
import { MonitoringStatusTextExtension } from '@/app/app/services/extensions/monitoring/monitoring-status-text.extension';
import { ScanTypeIconExtension } from '@/app/app/services/extensions/Scan/scan-type-icon.extension';
import { ScanTypeTranslationReferenceExtension } from '@/app/app/services/extensions/Scan/scan-type-translation-reference.extension';


@NgModule({
  imports: [
    AsyncPipe,
    DateFormatExtension,
    ListToValueExtension,
    MonitoringStatusIconExtension,
    MonitoringStatusTextExtension,
    NgForOf,
    NgIf,
    NotificationProgressComponent,
    PageHeaderComponent,
    ScanTypeIconExtension,
    ScanTypeTranslationReferenceExtension,

  ],
  providers: [
    DateExtension,
  ],
  exports: [
    AsyncPipe,
    CommonModule,
    DateFormatExtension,
    FormsModule,
    IonicModule,
    ListToValueExtension,
    MonitoringStatusIconExtension,
    MonitoringStatusTextExtension,
    NgForOf,
    NgIf,
    NotificationProgressComponent,
    PageHeaderComponent,
    ReactiveFormsModule,
    ScanTypeIconExtension,
    ScanTypeTranslationReferenceExtension,
    TranslateModule,
  ]
})
export class CoreModule {
}
